module.exports = __webpack_public_path__ + "static/media/6@3x.26ec2bff.png";